import { SIZE } from './sizes';

export const MENU_COLLAPSED_WIDTH = `${SIZE.SIX}px`;
export const MENU_EXPANDED_WIDTH = `${SIZE.TWENTY_SEVEN}px`;

export const HEADER_TITLE_HEIGHT = `${SIZE.EIGHT}px`;
export const HEADER_TABS_HEIGHT = `${SIZE.FIVE}px`;
export const HEADER_HEIGHT = `${SIZE.SEVEN + SIZE.HALF}px`;

export const SECURITY_FORM_HEIGHT = `${SIZE.FORTYEIGHT}px`;
export const SECURITY_FORM_WIDTH = `${SIZE.FIFTYTWO}px`;

export const BUTTON_ACTION_HEIGHT = `${SIZE.FOUR}px`;